/**
 * Конвертирует число в строку с %.
 */
export const toPercentage = (value: number): string => `${value}%`;
